import React, { useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import { ReportUsageContext } from 'src/pages/reportUsage';
import { TitleComponent } from 'src/pages/reportUsage/utils/reportUsage.styled';
import { PriceOverrideAlert } from 'src/pages/reportUsage/submit/components/submissionComplete.styled';
import AlertMsg from 'src/pages/reportUsage/common/AlertMsg';
import PatientInformation from 'src/pages/reportUsage/common/patientInformation/PatientInformation';
import ProcedureDetails from 'src/pages/reportUsage/common/procedureDetails/ProcedureDetails';
import BomBannerMessage from 'src/common/components/bomBannerMessage';
import ReviewItemsContainer from '../components/ReviewItemsContainer';
import ConfirmationCard from '../components/ConfirmationCard';
import {
    getTotalBilledItemsPrice,
    getTotalNonTissueItemsQty,
    getTotalTissueItemsQty,
} from './reviewUtil';
import { isMobileView } from 'src/utils/util';
import { useDynatracePageName } from 'src/common/hooks/useDynatracePageName';
import { VISIBLE, pageNames } from 'src/constants/appConstants';
import { useTranslation } from 'react-i18next';
import { COUNTRY_CODE_JAPN } from 'src/constants/productConstants';
import ReviewAndSubmitNotes from 'src/common/components/reviewAndSubmitNotes';
import Procedure from 'src/pages/procedure';
import PageLevelMessage from 'src/common/refactoredComponents/pageLevelMessage';
import warningAssets from 'src/assets/images/warning_alt.svg';

// import {
//     BackIcon,
//     BackIconContainer,
// } from '../../header/ReportUsageHeader.styled';
// import { sizes } from 'src/styles/Media.styled';
// import ArrowLeft from 'src/assets/images/ArrowLeftBack.svg';
// import DownArrow from 'src/assets/images/DownArrowFilter.svg';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const ReviewContainer = ({
    navigateToSpecifiedScreen,
    replenGridData,
    priceOverrideReason,
    emailInputBoxes,
    setEmailInputBoxes,
    isReportPayment = false,
    reportPaymentGridData,
    poTitle,
    handlePOTitle,
    handleSumTotal,
    displayPrice,
    setViewSurgeryNotes,
}) => {
    const { t } = useTranslation();
    const {
        usageDetails,
        reportUsageFormObj,
        footerButtonStatuses,
        setFooterButtonStatuses,
    } = useContext(ReportUsageContext);
  const isCondensedView = useSelector(
        (state) => state.loginReducer.isCondensedView
    );

    const procedurePageVisibility = useSelector(
        (state) => state.loginReducer.procedurePageVisibility
    );

    const signatureImg = useSelector(
        (state) =>
            state.reportUsageRootReducer.localSignatureDetails.base64Image
    );
    const dateOfSignature = useSelector(
        (state) =>
            state.reportUsageRootReducer.localSignatureDetails.dateOfSignature
    );
    const discrepencyUpdatedDetails = useSelector(
        (state) => state.reportUsageRootReducer.discrepencyUpdatedDetails
    );
    const discrepancyAttachment = useSelector(
        (state) => state.reportUsageRootReducer.discrepancyAttachment
    );
    const isConfirmationChecked = useSelector(
        (state) => state.reportUsageRootReducer.isConfirmationCheckboxChecked
    );

    // const usageOrderSubmission = useSelector(
    //     (state) => state.reportUsageRootReducer.usageOrderSubmission
    // );

    const isSubmitClicked = useSelector(
        (state) => state.reportUsageRootReducer.isSubmitClicked
    );

    // const orderStatus = useSelector(
    //     (state) => state.reportUsageRootReducer.orderStatus
    // );

    // const isUsagedSubmittedSuccessfully =
    //     (usageOrderSubmission && usageOrderSubmission.statusCode === '200') ||
    //     (Object.keys(orderStatus).length > 0 &&
    //         orderStatus.status &&
    //         orderStatus.status.includes('Usage Order Submitted Successfully'));

    const {
        patientIdVisibility,
        patientInformationVisibility,
        reportUsagePatientDetails,
        pediatricSurgery,
        procedureTypeUsageVisibility
    } = useSelector((state) => state.loginReducer);
    const procedureDetails = procedurePageVisibility && procedureTypeUsageVisibility === VISIBLE;
    const countryCode = localStorage.getItem('countryISOCode');
    const [billedItems, setBilledItems] = useState([]);
    // const [replenCount, setReplenCount] = useState(0);
    const [isConfirmationCheckboxChecked, setIsConfirmationCheckboxChecked] =
        useState(isConfirmationChecked);

    const reportUsageItems =
        reportUsageFormObj.products && reportUsageFormObj.products.length > 0
            ? reportUsageFormObj.products
            : [];
    const accountOwnedItems = reportUsageItems.filter(
        (item) => item.isAccountOwned
    );

    const restrictReviewScreen = useSelector(
        (state) => state.reportUsageRootReducer.restrictReviewScreen
    );

    const totalBilledItemsPrice = getTotalBilledItemsPrice(billedItems);
    const billedNonTissueItemsQty = getTotalNonTissueItemsQty(billedItems);
    const billedTissueItemsQty = getTotalTissueItemsQty(billedItems);
    useDynatracePageName(pageNames.reportUsageReviewAndSubmit);

    useEffectWithErrorLogging(() => {
        if (discrepencyUpdatedDetails?.discrepancyExists) {
            if (emailInputBoxes.length > 0) {
                const checkNonEmptyEmailLists =
                    emailInputBoxes.length >= 1
                        ? emailInputBoxes.filter((x) => x.value !== '')
                              ?.length > 0
                            ? true
                            : false
                        : false;

                if (
                    checkNonEmptyEmailLists &&
                    discrepancyAttachment?.length > 0
                ) {
                    setFooterButtonStatuses(
                        footerButtonStatuses.map((x) =>
                            x.btnName !==
                                t(
                                    'reportUsage.reportUsageFooterbuttons.cancelButton'
                                ) &&
                            x.btnName !==
                                t('equity.equityFooter.saveAndExitButton') &&
                            x.btnVisibility
                                ? {
                                      ...x,
                                      isBtnDisable:
                                          !isConfirmationCheckboxChecked,
                                  }
                                : x
                        )
                    );
                } else {
                    setFooterButtonStatuses(
                        footerButtonStatuses.map((x) =>
                            x.btnName !==
                                t(
                                    'reportUsage.reportUsageFooterbuttons.cancelButton'
                                ) &&
                            x.btnName !==
                                t('equity.equityFooter.saveAndExitButton') &&
                            x.btnVisibility
                                ? {
                                      ...x,
                                      isBtnDisable: true,
                                  }
                                : x
                        )
                    );
                }
            }
        } else {
            setFooterButtonStatuses(
                footerButtonStatuses.map((x) =>
                    x.btnName !==
                        t(
                            'reportUsage.reportUsageFooterbuttons.cancelButton'
                        ) &&
                    x.btnName !== t('equity.equityFooter.saveAndExitButton') &&
                    x.btnVisibility
                        ? {
                              ...x,
                              isBtnDisable: isReportPayment
                                  ? !isReportPayment
                                  : !isConfirmationCheckboxChecked,
                          }
                        : x
                )
            );
        }
    }, [
        isConfirmationCheckboxChecked,
        discrepancyAttachment?.length,
        emailInputBoxes,
    ]);

    useEffectWithErrorLogging(() => {
        if (
            reportUsageFormObj.products &&
            reportUsageFormObj.products.length > 0
        )
            setBilledItems(
                reportUsageFormObj?.products?.filter(
                    (item) => !item.isAccountOwned && item.unitPrice
                )
            );
        // let pr = reportUsageFormObj?.products?.filter((item) => {
        //     return item.isReplenish === false;
        // });
        // setReplenCount(pr?.length>0 ? pr.length :0);
        // console.log('===', replenCount);
    }, [reportUsageFormObj]);

    return (
        <React.Fragment>
            {/* {isReportPayment ? (
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <BackIconContainer isReplenScreen={isReportPayment}>
                        <BackIcon
                            src={
                                window.innerWidth <= sizes.mobileDevice
                                    ? ArrowLeft
                                    : DownArrow
                            }
                            alt={'backIcon'}
                            onClick={() =>
                                navigateToSpecifiedScreen('Review', true)
                            }
                        />
                    </BackIconContainer>

                    <TitleComponent paddingBottom={'5px'} paddingTop={'8px'}>
                        {'Review & Submit'}
                    </TitleComponent>
                </div>
            ) : ( */}
            <TitleComponent paddingBottom={'5px'} paddingTop={'8px'}>
                {t('equity.submit.reviewSubmit')}
            </TitleComponent>

            {/* )} */}
            {reportUsageFormObj.products &&
                reportUsageFormObj.products.some(
                    (item) => item.overrideUnitPrice
                ) &&
                (isReportPayment
                    ? reportPaymentGridData?.some(
                          (data) => data?.isPriceUpdated
                      )
                    : true) && (
                    <PriceOverrideAlert
                        margin={
                            discrepencyUpdatedDetails?.discrepancyExists
                                ? ' 0 0 11px 7px'
                                : '0 0 20px 7px'
                        }
                        alertMessageMobileMargin={'0 0 17px 4px'}
                    >
                        <AlertMsg message={t('reportUsage.submit.alertMsg')} />
                    </PriceOverrideAlert>
                )}
            {discrepencyUpdatedDetails?.discrepancyExists && (
                <PriceOverrideAlert
                    margin={'0 0 20px 7px'}
                    alertMessageMobileMargin={'0 0 17px 4px'}
                >
                    <AlertMsg
                        message={t(
                            'reportUsage.discrpancyAlertMessage.ImportantDiscrepancyAlert'
                        )}
                    />
                </PriceOverrideAlert>
            )}

            {reportUsageFormObj.products &&
                reportUsageFormObj.products.some(
                    (item) => item?.lotSerialUnknown
                ) && (
                    <PageLevelMessage
                        status="bomChange"
                        message={t(
                            'templates.equityTemplates.UnknownLotSerialNumber'
                        )}
                        messageTextAlign={'left'}
                        messagewhiteSpace={'nowrap'}
                        surgeryNumberTextAlign={'left'}
                        mycaseHeight={'113px'}
                        imgHeight={'auto'}
                        imgWidth={'auto'}
                        marginTop={isCondensedView ? '10px' : '20px'}
                        mbMarginTop={isCondensedView ? '10px' : ''}
                        marginBottom={isCondensedView ? '12px' : '0'}
                        isCondensedView={isCondensedView}
                        isFromReportUsage={true}
                        imgSrc={warningAssets}
                    />
                )}
            {(patientIdVisibility === VISIBLE ||
                patientInformationVisibility === VISIBLE) &&
                reportUsagePatientDetails?.length > 0 && (
                    <PatientInformation
                        navigateToSpecifiedScreen={navigateToSpecifiedScreen}
                        showEditButton={!isReportPayment}
                        reviewScreen={true}
                        title={
                            isMobileView()
                                ? t('common.patientDetails')
                                : t(
                                      'reportUsage.progressBar.PatientInformation'
                                  )
                        }
                    />
                )}
            {procedureDetails && !isReportPayment && (
                <ProcedureDetails
                    navigateToSpecifiedScreen={navigateToSpecifiedScreen}
                    showEditButton={!isReportPayment}
                    reviewScreen={true}
                />
            )}
            <ReviewItemsContainer
                usageDetails={usageDetails}
                discrepencyUpdatedDetails={discrepencyUpdatedDetails}
                billedItems={billedItems}
                setBilledItems={setBilledItems}
                accountOwnedItems={accountOwnedItems}
                priceOverrideReason={priceOverrideReason}
                signatureDetails={
                    signatureImg?.length > 0 &&
                    dateOfSignature?.length > 0 && {
                        base64Image: signatureImg,
                        dateOfSignature,
                    }
                }
                navigateToSpecifiedScreen={navigateToSpecifiedScreen}
                replenGridData={replenGridData}
                totalBilledItemsPrice={totalBilledItemsPrice}
                billedNonTissueItemsQty={billedNonTissueItemsQty}
                billedTissueItemsQty={billedTissueItemsQty}
                emailInputBoxes={emailInputBoxes}
                setEmailInputBoxes={setEmailInputBoxes}
                isReportPayment={isReportPayment}
                reportPaymentGridData={reportPaymentGridData}
                poTitle={poTitle}
                handlePOTitle={handlePOTitle}
                handleSumTotal={handleSumTotal}
                displayPrice={displayPrice}
                // isSubmitClicked={isSubmitClicked}
            />
            <ReviewAndSubmitNotes
                isFromReportUsage={true}
                setViewSurgeryNotes={setViewSurgeryNotes}
                isSubmitClicked={isSubmitClicked}
                reportPaymentGridData={reportPaymentGridData}
                isReportPayment={isReportPayment}
                // replenCount = {replenCount}
            />
            {!isReportPayment && (
                <ConfirmationCard
                    isConfirmationCheckboxChecked={
                        isConfirmationCheckboxChecked
                    }
                    setIsConfirmationCheckboxChecked={
                        setIsConfirmationCheckboxChecked
                    }
                />
            )}

            {/* {isUsagedSubmittedSuccessfully ||
            isSubmitClicked ||
            usageOrderSubmission?.clickedBtn === 'submit'
                ? // || !restrictReviewScreen
                  null
                : !isReportPayment && (
                      <ConfirmationCard
                          isConfirmationCheckboxChecked={
                              isConfirmationCheckboxChecked
                          }
                          setIsConfirmationCheckboxChecked={
                              setIsConfirmationCheckboxChecked
                          }
                      />
                  )} */}
        </React.Fragment>
    );
};

export default ReviewContainer;
